import { Box } from "devextreme-react";
import { Item } from "devextreme-react/box";
import { useRef } from "react";
import DivisionList from "./DivisionList";
import EmployeeWrapper from "./EmployeeWrapper";

export default function List() {
  const employeeDataGridRef = useRef(null);
  // const employeeTileViewRef = useRef(null);

  return (
    <div>
      <Box direction="row" width={"100%"}>
        <Item ratio={0} baseSize={400}>
          <DivisionList
            employeeDataGridRef={employeeDataGridRef}
            // employeeTileViewRef={employeeTileViewRef}
          />
        </Item>
        <Item ration={1} baseSize={"80%"}>
          <EmployeeWrapper
            employeeDataGridRef={employeeDataGridRef}
            // employeeTileViewRef={employeeTileViewRef}
          />
        </Item>
      </Box>
    </div>
  );
}
